document.addEventListener("DOMContentLoaded", function() {
  var section = document.getElementById("shopify-section-template--16792825856172__contact_form_8hXD4t");
  if (!section) return; 
  
  var image = section.querySelector(".image-with-text__media img");
  if (!image) return;

  var video = document.createElement("video");
  video.setAttribute("controls", "true"); 
  video.setAttribute("width", "100%"); 
  video.setAttribute("autoplay", "true");

  var source = document.createElement("source");
  source.setAttribute("src", "https://cdn.shopify.com/videos/c/o/v/e6f0e856c52c423f97a6096940f7cf5f.mp4");
  source.setAttribute("type", "video/mp4"); 

  video.appendChild(source);

  image.parentNode.replaceChild(video, image);
});


document.addEventListener('DOMContentLoaded', function () {
  const links = document.querySelectorAll('a');

  links.forEach(link => {
    const isExternal = link.hostname && link.hostname !== location.hostname;

    if (isExternal) {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer'); // Recommended for security
    }
  });
});
